// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"470":"87eebdad","483":"87eebdad","498":"87eebdad","638":"87eebdad","645":"87eebdad","808":"87eebdad","975":"87eebdad"}[chunkId] + ".chunk.css";
};